import React from "react";
import { Box, Container, Typography, Button, Stack, Grid } from "@mui/material";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const PURPLE = "#7C3AED";
const BG     = "#030014";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";
const INK3   = "#7D8390";

const SolutionCTA = ({
  headline,
  subheadline,
  primaryCTA,
  primaryCTALink,
  secondaryCTA,
  secondaryCTALink,
  stats,
}) => (
  <Box sx={{
    py: { xs: 15, md: 20 }, textAlign: "center",
    background: `radial-gradient(700px 350px at 50% 50%, rgba(226,104,74,0.10), transparent 60%), ${BG}`,
    borderTop: `1px solid ${LINE}`,
  }}>
    <Container maxWidth="lg">
      {/* Stats row */}
      {stats && stats.length > 0 && (
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {stats.map((stat, i) => (
            <Grid item xs={6} md={3} key={i}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, delay: i * 0.1 }}
                viewport={{ once: true }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography sx={{
                    fontFamily: "'IBM Plex Serif', serif",
                    fontWeight: 600, letterSpacing: "-0.02em",
                    fontSize: { xs: "2.5rem", md: "3.5rem" },
                    background: `linear-gradient(135deg, ${ACCENT} 0%, ${PURPLE} 100%)`,
                    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                  }}>
                    {stat.value}
                  </Typography>
                  <Typography sx={{ color: INK2, mt: 0.75, fontSize: "14px" }}>{stat.label}</Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      )}

      <motion.div
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.55 }}
      >
        <Typography sx={{ fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em", textTransform: "uppercase", color: ACCENT, mb: 2 }}>
          Ready to Get Started
        </Typography>
        <Typography sx={{
          fontFamily: "'IBM Plex Serif', serif",
          fontSize: { xs: "1.8rem", md: "2.75rem" },
          fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.15,
          color: INK, maxWidth: 640, mx: "auto", mb: 2.5,
        }}>
          {headline}
        </Typography>
        <Typography sx={{ color: INK2, fontSize: "1.05rem", lineHeight: 1.7, maxWidth: 560, mx: "auto", mb: 4.5 }}>
          {subheadline}
        </Typography>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon />}
            onClick={() => window.location.href = primaryCTALink || "/contact-us"}
            sx={{ px: 5, py: 1.8, fontSize: "15px" }}
          >
            {primaryCTA}
          </Button>
          {secondaryCTA && (
            <Button
              variant="outlined"
              size="large"
              onClick={() => window.location.href = secondaryCTALink || "/case-studies"}
              sx={{ px: 5, py: 1.8, fontSize: "15px" }}
            >
              {secondaryCTA}
            </Button>
          )}
        </Stack>
      </motion.div>
    </Container>
  </Box>
);

export default SolutionCTA;
